import request from '@/utils/request'

export function getPointsRecordPage(params) {
  return request({
    url: '/admin/points/record/page',
    method: 'get',
    params
  })
}

export function getUserPointsRecords(userId, params) {
  return request({
    url: `/admin/points/record/user/${userId}`,
    method: 'get',
    params
  })
}

export function getPointsSummary(userId) {
  return request({
    url: `/admin/points/summary/${userId}`,
    method: 'get'
  })
}

export function manualAddPoints(data) {
  return request({
    url: '/admin/points/manual-add',
    method: 'post',
    data
  })
}

export function manualDeductPoints(data) {
  return request({
    url: '/admin/points/manual-deduct',
    method: 'post',
    data
  })
}

export function getPointsStatistics(activeDays) {
  return request({
    url: '/admin/points/statistics',
    method: 'get',
    params: { activeDays }
  })
}

export function batchAddPointsByLevel(data) {
  return request({
    url: '/admin/points/batch-add',
    method: 'post',
    data
  })
}
